import * as React from "react";
import { IListingModel } from "../../../models/IPatient";
import { Table } from "soprasteria-ui-library";
import { dateTimeToDateString } from "../../../helpers/DateHelper"

interface IListingHistory {
    listings?: IListingModel[]
}



export const PatientListingHistory: React.FunctionComponent<IListingHistory> = ({ listings }) => {

    return (
        <section>
            <Table>
                <thead>
                    <tr>
                        <th>Vårdgivare</th>
                        <th>Mottagning</th>
                        <th>Fr.o.m.</th>
                        <th>T.o.m.</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        listings && listings.length > 0
                            ? listings.map((listing, key) => {
                                return (
                                    <tr key={key}>
                                        <td>{listing.careProvider.displayOrganisationInformation}</td>
                                        <td>{listing.careProvider.displayCareProviderName}</td>
                                        <td>{dateTimeToDateString(listing.startDate)}</td>
                                        <td>{listing.endDate ? dateTimeToDateString(listing.endDate) : ""}</td>
                                    </tr>
                                )
                            })
                            : <tr><td colSpan={4}>Patienten har ingen tidigare listning på mottagningen</td></tr>
                    }
                </tbody>
            </Table>
        </section>
    )
}